(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["StressReliefNewFAQ"] && !Shopify.designMode) return;
  try {
    
  $("#accordion").on("hide.bs.collapse show.bs.collapse", e => {
      $(e.target)
        .prev()
        .find("i:last-child")
        .toggleClass("fa-minus fa-plus");
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brain-protect-FAQ"] && !Shopify.designMode) return;
  try {
    
        $("#accordion").on("hide.bs.collapse show.bs.collapse", e => {
            $(e.target)
              .prev()
              .find("i:last-child")
              .toggleClass("fa-minus fa-plus");
          });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-product-faq"] && !Shopify.designMode) return;
  try {
    
        $("#accordion").on("hide.bs.collapse show.bs.collapse", e => {
            $(e.target)
              .prev()
              .find("i:last-child")
              .toggleClass("fa-minus fa-plus");
          });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-bf-faq"] && !Shopify.designMode) return;
  try {
    
        $("#accordion").on("hide.bs.collapse show.bs.collapse", e => {
            $(e.target)
              .prev()
              .find("i:last-child")
              .toggleClass("fa-minus fa-plus");
          });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faq"] && !Shopify.designMode) return;
  try {
    
        $("#accordion").on("hide.bs.collapse show.bs.collapse", e => {
            $(e.target)
              .prev()
              .find("i:last-child")
              .toggleClass("fa-minus fa-plus");
          });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-omega-3-faq"] && !Shopify.designMode) return;
  try {
    
        $("#accordion").on("hide.bs.collapse show.bs.collapse", e => {
            $(e.target)
              .prev()
              .find("i:last-child")
              .toggleClass("fa-minus fa-plus");
          });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-sleep-forte-faq"] && !Shopify.designMode) return;
  try {
    
        $("#accordion").on("hide.bs.collapse show.bs.collapse", e => {
            $(e.target)
              .prev()
              .find("i:last-child")
              .toggleClass("fa-minus fa-plus");
          });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-stress-faq"] && !Shopify.designMode) return;
  try {
    
        $("#accordion").on("hide.bs.collapse show.bs.collapse", e => {
            $(e.target)
              .prev()
              .find("i:last-child")
              .toggleClass("fa-minus fa-plus");
          });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-sw-faq"] && !Shopify.designMode) return;
  try {
    
        $("#accordion").on("hide.bs.collapse show.bs.collapse", e => {
            $(e.target)
              .prev()
              .find("i:last-child")
              .toggleClass("fa-minus fa-plus");
          });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vegan_omega_certifications"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('vegan-certifications-slider')) return;

    class VeganCertificationsSlider extends HTMLElement {
      constructor() {
        super();
        this.autoscrollFrame = null;
        this.autoscrollResumeTimer = null;
        this.lastFrameTime = null;
        this.autoscrollPosition = 0;
        this.loopStart = 0;
        this.loopPoint = 0;
        this.firstClone = null;
        this.mobileMediaQuery = window.matchMedia('(max-width: 899px)');
        this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.resizeObserver = new ResizeObserver(() => {
          this.loopStart = 0;
          this.loopPoint = 0;
        });
        this.onMediaChange = this.onMediaChange.bind(this);
        this.onPointerDown = this.onPointerDown.bind(this);
        this.onPointerUp = this.onPointerUp.bind(this);
        this.onMouseEnter = this.onMouseEnter.bind(this);
        this.onMouseLeave = this.onMouseLeave.bind(this);
        this.onVisibilityChange = this.onVisibilityChange.bind(this);
        this.runAutoscroll = this.runAutoscroll.bind(this);
        this.scheduleAutoscroll = this.scheduleAutoscroll.bind(this);
      }

      connectedCallback() {
        this.track = this.querySelector('[data-vegan-certifications-track]');
        this.slides = Array.from(this.querySelectorAll('[data-vegan-certifications-slide]'));

        if (!this.track || this.dataset.mobileSlider !== 'true') return;

        this.createAutoscrollClones();
        this.mobileMediaQuery.addEventListener('change', this.onMediaChange);
        this.reducedMotionQuery.addEventListener('change', this.onMediaChange);
        this.track.addEventListener('pointerdown', this.onPointerDown);
        this.track.addEventListener('pointerup', this.onPointerUp);
        this.track.addEventListener('pointercancel', this.onPointerUp);
        this.track.addEventListener('mouseenter', this.onMouseEnter);
        this.track.addEventListener('mouseleave', this.onMouseLeave);
        this.resizeObserver.observe(this.track);
        document.addEventListener('visibilitychange', this.onVisibilityChange);
        this.updateAutoscroll();
      }

      disconnectedCallback() {
        this.stopAutoscroll();
        this.mobileMediaQuery.removeEventListener('change', this.onMediaChange);
        this.reducedMotionQuery.removeEventListener('change', this.onMediaChange);
        this.track?.removeEventListener('pointerdown', this.onPointerDown);
        this.track?.removeEventListener('pointerup', this.onPointerUp);
        this.track?.removeEventListener('pointercancel', this.onPointerUp);
        this.track?.removeEventListener('mouseenter', this.onMouseEnter);
        this.track?.removeEventListener('mouseleave', this.onMouseLeave);
        this.resizeObserver.disconnect();
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
      }

      onMediaChange() {
        this.updateAutoscroll();
      }

      onPointerDown() {
        this.stopAutoscroll();
      }

      onPointerUp() {
        this.scheduleAutoscroll();
      }

      onMouseEnter() {
        this.stopAutoscroll();
      }

      onMouseLeave() {
        this.scheduleAutoscroll();
      }

      onVisibilityChange() {
        this.updateAutoscroll();
      }

      updateAutoscroll() {
        this.stopAutoscroll();

        if (
          this.dataset.mobileAutoscroll !== 'true' ||
          !this.mobileMediaQuery.matches ||
          this.reducedMotionQuery.matches ||
          document.hidden ||
          this.slides.length < 2
        ) {
          return;
        }

        this.lastFrameTime = null;
        this.autoscrollPosition = this.track.scrollLeft;
        this.autoscrollFrame = window.requestAnimationFrame(this.runAutoscroll);
      }

      scheduleAutoscroll() {
        this.stopAutoscroll();
        this.autoscrollResumeTimer = window.setTimeout(() => this.updateAutoscroll(), 1000);
      }

      stopAutoscroll() {
        if (this.autoscrollFrame) {
          window.cancelAnimationFrame(this.autoscrollFrame);
          this.autoscrollFrame = null;
        }

        if (this.autoscrollResumeTimer) {
          window.clearTimeout(this.autoscrollResumeTimer);
          this.autoscrollResumeTimer = null;
        }

        this.lastFrameTime = null;
      }

      createAutoscrollClones() {
        if (this.dataset.mobileAutoscroll !== 'true' || this.slides.length < 2) return;

        this.firstClone = this.track.querySelector('[data-vegan-certifications-clone]');
        if (this.firstClone) return;

        this.slides.forEach((slide) => {
          const clone = slide.cloneNode(true);
          clone.removeAttribute('data-vegan-certifications-slide');
          clone.removeAttribute('data-shopify-editor-block');
          clone.setAttribute('data-vegan-certifications-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          clone.setAttribute('inert', '');
          clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
          clone
            .querySelectorAll('[data-shopify-editor-block]')
            .forEach((element) => element.removeAttribute('data-shopify-editor-block'));
          this.track.appendChild(clone);
          this.firstClone = this.firstClone || clone;
        });
      }

      runAutoscroll(timestamp) {
        if (this.lastFrameTime === null) {
          this.lastFrameTime = timestamp;
        }

        const elapsedSeconds = (timestamp - this.lastFrameTime) / 1000;
        const speed = Number(this.dataset.mobileAutoscrollSpeed) || 30;

        if (!this.loopPoint && this.firstClone) {
          const trackRect = this.track.getBoundingClientRect();
          const firstSlidePosition =
            this.slides[0].getBoundingClientRect().left - trackRect.left + this.track.scrollLeft;
          const firstClonePosition =
            this.firstClone.getBoundingClientRect().left - trackRect.left + this.track.scrollLeft;

          this.loopStart = firstSlidePosition;
          this.loopPoint = firstClonePosition - firstSlidePosition;
        }

        if (this.loopPoint > 0) {
          this.autoscrollPosition += speed * elapsedSeconds;

          if (this.autoscrollPosition >= this.loopStart + this.loopPoint) {
            this.autoscrollPosition =
              this.loopStart + ((this.autoscrollPosition - this.loopStart) % this.loopPoint);
          }

          this.track.scrollLeft = this.autoscrollPosition;
        }

        this.lastFrameTime = timestamp;
        this.autoscrollFrame = window.requestAnimationFrame(this.runAutoscroll);
      }
    }

    customElements.define('vegan-certifications-slider', VeganCertificationsSlider);
  })();

  } catch(e) { console.error(e); }
})();
})();
